// Formatos de número da Visão Geral (pt-BR).
export const BRL = (v) =>
  "R$ " + Number(v || 0).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const BRL0 = (v) => "R$ " + Math.round(Number(v || 0)).toLocaleString("pt-BR");

export const PCT = (v) =>
  Number(v || 0).toLocaleString("pt-BR", { minimumFractionDigits: 1, maximumFractionDigits: 1 }) + "%";

export const INT = (v) => Math.round(Number(v || 0)).toLocaleString("pt-BR");

/** 12.345 → "12,3 mil"; 1.234.567 → "1,23 mi". */
export const MIL = (v) => {
  const n = Number(v || 0);
  if (Math.abs(n) >= 1e6) return (n / 1e6).toLocaleString("pt-BR", { maximumFractionDigits: 2 }) + " mi";
  if (Math.abs(n) >= 1e3) return (n / 1e3).toLocaleString("pt-BR", { minimumFractionDigits: 1, maximumFractionDigits: 1 }) + " mil";
  return Math.round(n).toLocaleString("pt-BR");
};

/** Variação em % de `atual` sobre `base`; null quando não há base. */
export const variacao = (atual, base) => (base ? ((atual - base) / base) * 100 : null);

export const pad2 = (n) => String(n).padStart(2, "0");

export const MESES = ["janeiro", "fevereiro", "março", "abril", "maio", "junho", "julho", "agosto", "setembro", "outubro", "novembro", "dezembro"];
export const MESES_CURTOS = ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"];
export const DIAS_SEMANA_JS = ["Domingo", "Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado"];

/** "2026-10-23" → Date local (sem fuso: meia-noite do dia). */
export const dataLocal = (iso) => {
  const [a, m, d] = String(iso).slice(0, 10).split("-").map(Number);
  return new Date(a, m - 1, d);
};

/** Dia da semana 0=segunda (como o backend) a partir de "AAAA-MM-DD". */
export const diaSemanaSeg = (iso) => (dataLocal(iso).getDay() + 6) % 7;
